<template>
  <svg
    class="arrow-icon"
    :class="direction && `rotate-icon--${direction}`"
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.47508 1.53254C0.209877 1.24844 0.216918 0.805447 0.491016 0.529919C0.779226 0.240208 1.25015 0.246975 1.52991 0.544848L5.07125 4.3154C5.43269 4.70024 5.43269 5.29976 5.07125 5.6846L1.52991 9.45516C1.25015 9.75303 0.779228 9.7598 0.491022 9.47009C0.216921 9.19456 0.209883 8.75157 0.475093 8.46747L3.71197 5.00007L0.47508 1.53254Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Arrow',
  props: {
    direction: {
      type: String,
      default: '',
    },
  },
};
</script>
